
export const PRESCREEN_QUESTIONS_CONFIG = {
  globalAnswers: {
    title: 'Common Questions (saved for pre-fill to other jobs)',
    subtitle: ''
  }
};
